/**
 * MenuList
 * 
 * @Author: Focci
 * @Date: 2023-07-24 22:01:50
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-24 22:01:50
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { List, ListItem, ListItemButton } from '@comp/material'
import { isFunction } from 'lodash-es'

export default function MenuList({
  options = [],
  value = null,
  // 显示右边数量
  badges = {},
  prefix,
  badgeClassName = 'ml-auto border broder-ce6 bg-white rounded-full px-1.5 text-f.6 shadow-sm text-primary',
  onClick = () => {},
  className = 'text-f.8 font-medium'
}) {
  return (
    <List>
      {options.map((option, index) => (
        <ListItem
          key={option.value}
          disablePadding
          className={clsx([
            className,
            option.value !== value && 'bg-[#F2F5F7] hover:bg-[#F2F5F7]',
            option.value === value && 'text-primary bg-white',
            index > 0 && 'border-t border-t-solid'
          ])}
        >
          <ListItemButton 
            className="py-2.5" 
            onClick={() => onClick(option, index)}
          >
            {isFunction(prefix) && prefix({ option, index })}
            <span>{option.label}</span>
            {!!badges[option.value] && (
              <span className={badgeClassName}>
                {badges[option.value]}
              </span>
            )}
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  )
}

MenuList.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  // counts: PropTypes.object,
  onClick: PropTypes.func,
}
